import React, { useEffect, useRef, useState } from "react";
import { FaExclamationCircle } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import styles from "./AdharRegistrartion.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  generateAadhaarOtp,
  genetateMobileOtp,
  getUserDetails,
  verifyAadharOtp,
  verifyMobileOtp,
  getAbhaAddressSuggestion,
  setAbhaAddress,
  downloadAbhaCard,
} from "../../../../store/slices/abhaRegistrationSlice";
import { jsPDF } from "jspdf";
import {
  MAX_OTP_RESEND_ATTEMPTS,
  getOtpResendAttemptMessage,
} from "./otpResendAttempts";

const AdharRegistration = ({
  clinicId,
  clinicName,
  setModalVisible,
  setShowRegistrationModal,
  adharOtpGenerateMsg,
  loading,
  setAadharNumber,
}) => {
  const consentTexts = [
    `I am voluntarily sharing my Aadhaar Number / Virtual ID issued by UIDAI, and my demographic information for the purpose of creating an Ayushman Bharat Health Account number (“ABHA number”) and address (“ABHA Address”). I authorize NHA to use my Aadhaar number / VID for authentication with UIDAI as per the Aadhaar Act, 2016. I understand UIDAI will share my e-KYC details or a “Yes” response with NHA upon successful authentication.`,
    `I intend to create ABHA number and ABHA Address using a document other than Aadhaar. (Click here to proceed further)`,
    `I consent to usage of my ABHA address and number for linking of my legacy (past) government health records and those generated during this encounter.`,
    `I authorize the sharing of all my health records with healthcare provider(s) for the purpose of providing healthcare services during this encounter.`,
    `I consent to the anonymization and subsequent use of my government health records for public health purposes.`,
    `I, (name of healthcare worker), confirm that I have duly informed and explained the beneficiary about this consent form.`,
    `I, (beneficiary name), have been explained the above and hereby provide my consent.`,
  ];
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const [showOtpVerification, setShowOtpVerification] = useState(false);
  const [aadhaarError, setAadhaarError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showMobileEmailVerification, setShowMobileEmailVerification] =
    useState(false);
  const [showFinalStep, setShowFinalStep] = useState(false);
  const [aadhaarPart1, setAadhaarPart1] = useState("");
  const [aadhaarPart2, setAadhaarPart2] = useState("");
  const [aadhaarPart3, setAadhaarPart3] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpError, setOtpError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileOtpDigits, setMobileOtpDigits] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const mobileOtpRefs = useRef([]);
  const [mobileOtpError, setMobileOtpError] = useState("");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [timer, setTimer] = useState(0);
  const [mobileTimer, setMobileTimer] = useState(0);
  const inputRefs = useRef([]);
  const [abhaAddressList, setAbhaAddressList] = useState([]);
  const [showOtpInput, setShowOtpInput] = useState(true);
  const [selectedAbhaAddress, setSelectedAbhaAddress] = useState("");
  const [showAlreadyRegisteredModal, setShowAlreadyRegisteredModal] =
    useState(false);
  const [showAbhaMob, setShowAbhaMob] = useState(true);
  const [isEditable, setIsEditable] = useState(true);
  const [abhaNumberErrorMessage, setAbhaNumberErrorMessage] = useState("");
  const [canSendOtp, setCanSendOtp] = useState(false);
  const [manualAbhaAddress, setManualAbhaAddress] = useState("");
  const [showAbhaAddressSection, setShowAbhaAddressSection] = useState(false);
  const [abhaAddressErrorMessage, setAbhaAddressErrorMessage] = useState("");
  const [showAbhaCard, setShowAbhaCard] = useState(false);
  const [abhaCard, setAbhaCard] = useState("");
  const [patientName, setPatientName] = useState("");
  const [aadhaarOtpResendCount, setAadhaarOtpResendCount] = useState(0);
  const [mobileOtpResendCount, setMobileOtpResendCount] = useState(0);
  const [showConsentError, setShowConsentError] = useState(false);
  const [checkedState, setCheckedState] = useState(
    new Array(consentTexts.length).fill(false)
  );
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const [beneficiaryNameError, setBeneficiaryNameError] = useState("");

  useEffect(() => {
    mobileOtpRefs.current[0]?.focus();
    inputRefs.current[0]?.focus();
  }, []);

  useEffect(() => {
    if (timer <= 0) return;
    const interval = setInterval(() => setTimer((t) => t - 1), 1000);
    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    if (mobileTimer <= 0) return;
    const interval = setInterval(() => setMobileTimer((t) => t - 1), 1000);
    return () => clearInterval(interval);
  }, [mobileTimer]);

  const startOtpTimer = () => setTimer(60);
  const startMobileOtpTimer = () => setMobileTimer(60);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCheckboxChange = (index) => {
    const updatedCheckedState = checkedState?.map((item, idx) =>
      idx === index ? !item : item
    );
    setCheckedState(updatedCheckedState);
    setShowConsentError("");
  };

  const handleNextClick = async () => {
    const fullAadhaar = aadhaarPart1 + aadhaarPart2 + aadhaarPart3;
    setAadhaarNumber(fullAadhaar);

    if (fullAadhaar.length !== 12 || !/^\d{12}$/.test(fullAadhaar)) {
      setAadhaarError("Please enter a valid 12-digit Aadhaar number.");
      return;
    }

    const anyUnchecked = checkedState?.some(
      (isChecked, idx) => idx !== 1 && !isChecked
    );
    if (anyUnchecked) {
      setShowConsentError(true);
      return;
    }
    setShowConsentError(false);

    if (!beneficiaryName.trim()) {
      setBeneficiaryNameError("Please enter the beneficiary name.");
      return;
    }
    setBeneficiaryNameError("");

    try {
      setAadhaarError("");
      const response = await dispatch(
        generateAadhaarOtp({
          loginId: fullAadhaar,
          clinicId,
          token,
        })
      ).unwrap();
      if (!response.success) {
        setAadhaarError("Invalid Aadhaar number. Please try again.");
        return;
      }
      setAadharNumber(fullAadhaar);
      setShowOtpVerification(true);
      startOtpTimer();
    } catch (err) {
      console.error("Aadhaar verification error:", err);
      setAadhaarError("Something went wrong. Please try again.");
    }
  };

  const handleFinalNextClick = async () => {
    const otpValue = otp.join("");
    let hasError = false;
    setOtpError("");
    setMobileError("");
    if (otpValue.length !== 6) {
      setOtpError("Please enter a valid 6-digit OTP.");
      hasError = true;
    }
    if (!/^\d{10}$/.test(mobileNumber)) {
      setMobileError("Please enter a valid 10-digit mobile number.");
      hasError = true;
    }
    if (hasError) return;
    try {
      const otpResponse = await dispatch(
        verifyAadharOtp({
          clinicId,
          mobile: mobileNumber,
          otp: otpValue,
          token,
        })
      ).unwrap();

      if (otpResponse.success) {
        const userDetailsResponse = await dispatch(
          getUserDetails({ clinicId, token })
        ).unwrap();
        const userDetails = userDetailsResponse?.result?.list;
        setPatientName(userDetailsResponse?.result?.list?.name || "Patient");
        if (
          otpResponse?.result?.list?.message === "This account already exist" &&
          userDetailsResponse.success
        ) {
          setShowAlreadyRegisteredModal(true);
          return;
        }
        if (userDetails?.mobile !== mobileNumber) {
          await dispatch(
            genetateMobileOtp({
              clinicId,
              mobile: mobileNumber,
              token,
            })
          ).unwrap();
          startMobileOtpTimer();
        } else {
          setShowOtpInput(false);
          setShowAbhaMob(false);
          setShowAbhaAddressSection(true);
        }
        const addressResponse = await dispatch(
          getAbhaAddressSuggestion({
            clinicId,
            token,
          })
        );
        if (addressResponse.payload.success === true) {
          setAbhaAddressList(
            addressResponse?.payload?.result?.list?.abhaAddressList
          );
        }
        setShowOtpVerification(false);
        setShowMobileEmailVerification(true);
        setShowFinalStep(false);
      } else {
        setOtpError("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error during OTP verification, Please Try Again", error);
      setOtpError("Something went wrong while verifying OTP.");
    }
  };

  const handleLastNextClick = async () => {
    try {
      if (showOtpInput) {
        const fullOtp = mobileOtpDigits.join("");
        if (fullOtp?.length !== 6) {
          setMobileOtpError("Please enter a valid 6-digit OTP.");
          return;
        }
        const response = await dispatch(
          verifyMobileOtp({
            clinicId,
            mobile: mobileNumber,
            otp: fullOtp,
            token,
          })
        ).unwrap();
        if (!response.success) {
          setMobileOtpError("Invalid OTP. Please try again.");
          return;
        }
        setShowFinalStep(true);
        setMobileOtpError("");
        setShowAbhaAddressSection(true);
      }
    } catch (err) {
      console.error("Mobile OTP verification error:", err);
      setMobileOtpError("Invalid OTP. Please try again.");
    }
  };

  const handleEndNextClick = async () => {
    try {
      if (!selectedAbhaAddress && !manualAbhaAddress) {
        setAbhaAddressErrorMessage("Please select or enter an ABHA address.");
        return;
      }
      if (abhaAddressErrorMessage !== "") {
        setAbhaAddressErrorMessage("Please enter a valid ABHA address.");
        return;
      }
      const abhaAddress = selectedAbhaAddress || manualAbhaAddress;
      const responseData = await dispatch(
        setAbhaAddress({ clinicId, abhaAddress, token })
      ).unwrap();
      if (responseData?.success) {
        const downloadResponse = await dispatch(
          downloadAbhaCard({ clinicId, token })
        ).unwrap();
        if (downloadResponse?.success) {
          setAbhaCard(downloadResponse?.result?.list?.base64Image);
          setShowAbhaCard(true);
        } else {
          setAbhaAddressErrorMessage(
            "Failed to download ABHA card. Please try again."
          );
          console.error("Failed to download ABHA card:", downloadResponse);
        }
      } else {
        setAbhaAddressErrorMessage(
          "Failed to set ABHA address. Please Select/Type another One."
        );
      }
    } catch (err) {
      console.error(" Error While Set Abha Address ", err);
    }
  };

  const handleDownloadAbhaCard = () => {
    const doc = new jsPDF();
    const img = new Image();
    img.src = abhaCard;

    img.onload = () => {
      doc.addImage(img, "JPEG", 10, 10, 190, 120);
      const fileName =
        patientName && patientName?.trim() !== ""
          ? `${patientName}_abha_card.pdf`
          : "abhacard.pdf";
      doc?.save(fileName);
    };
  };

  const handleFinalEndNextClick = async () => {
    try {
      const userRes = await dispatch(
        getUserDetails({ clinicId, token })
      ).unwrap();
      if (userRes?.success) {
        setShowRegistrationModal(false);
        setModalVisible(true);
      }
    } catch (err) {
      console.error("Something Went Wrong", err);
      setMobileOtpError("Something Went Wrong, Please Try Again.");
    }
  };

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const handleInputChange = (e, setPart, maxLength, nextRef, prevRef) => {
    setAadhaarError("");
    const value = e.target.value.replace(/\D/g, "");
    setPart(value);
    if (value?.length === maxLength && nextRef) {
      nextRef.current.focus();
    }
    if (
      value.length === 0 &&
      prevRef &&
      e.nativeEvent.inputType === "deleteContentBackward"
    ) {
      prevRef.current.focus();
    }
  };

  const handleOtpChange = (e, index) => {
    const value = e?.target?.value;
    if (/^\d$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setOtpError("");
      if (value !== "" && index < otp?.length - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleMobileOtpChange = (e, index) => {
    const value = e?.target?.value;
    if (/^\d$/.test(value) || value === "") {
      const newOtp = [...mobileOtpDigits];
      newOtp[index] = value;
      setMobileOtpDigits(newOtp);
      setMobileOtpError("");
      if (value !== "" && index < mobileOtpDigits?.length - 1) {
        mobileOtpRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleMobileOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && mobileOtpDigits[index] === "" && index > 0) {
      mobileOtpRefs.current[index - 1]?.focus();
    }
  };
  const handleResendOtp = async () => {
    setOtpError("");

    if (timer > 0) return;

    if (aadhaarOtpResendCount >= MAX_OTP_RESEND_ATTEMPTS) {
      setOtpError("All OTP resend attempts have been used.");
      return;
    }

    try {
      await dispatch(
        generateAadhaarOtp({
          loginId: aadhaarNumber,
          clinicId: clinicId,
          token,
        })
      ).unwrap();
      setAadhaarOtpResendCount((prevCount) => prevCount + 1);
      startOtpTimer();
    } catch (err) {
      console.error("Error during OTP resend:", err);
      setOtpError("Failed to resend OTP. Please try again.");
    }
  };

  const handleResendMobileOtp = async () => {
    setMobileOtpError("");

    if (mobileTimer > 0) return;

    if (mobileOtpResendCount >= MAX_OTP_RESEND_ATTEMPTS) {
      setMobileOtpError("All OTP resend attempts have been used.");
      return;
    }
    try {
      await dispatch(
        genetateMobileOtp({
          clinicId,
          mobile: mobileNumber,
          token,
        })
      ).unwrap();
      setMobileOtpResendCount((prev) => prev + 1);
      startMobileOtpTimer();
    } catch (err) {
      console.error("Error during mobile OTP resend:", err);
      setMobileOtpError("Failed to resend OTP. Please try again.");
    }
  };

  const handleAbhaAddressChange = (e) => {
    setAbhaAddressErrorMessage("");
    const selectedValue = e.target.value;
    setSelectedAbhaAddress(selectedValue);
    setManualAbhaAddress("");
  };

  const handleManualAbhaChange = (e) => {
    const value = e.target.value;
    setManualAbhaAddress(value);
    setSelectedAbhaAddress("");

    const abhaPattern =
      /^(?=.{8,18}$)(?![._])[a-zA-Z0-9]+([._]{1}[a-zA-Z0-9]+)?(?<![._])$/;

    if (!abhaPattern?.test(value)) {
      setAbhaAddressErrorMessage(
        "ABHA address must be 8–18 characters, alphanumeric, and may contain one '.' or '_' (not at start/end)."
      );
    } else {
      setAbhaAddressErrorMessage("");
    }
  };

  const handleGoToPatientRegistration = () => {
    setShowAlreadyRegisteredModal(false);
    setShowRegistrationModal(false);
    setModalVisible(true);
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setMobileNumber(value);
      setAbhaNumberErrorMessage("");
    }
  };

  const handleEditClick = () => {
    setIsEditable(false);
    setShowOtpInput(false);
    setCanSendOtp(true);
  };

  const handleSendClick = async () => {
    if (mobileNumber.length !== 10) {
      setAbhaNumberErrorMessage("Mobile number must be 10 digits");
      return;
    }
    setAbhaNumberErrorMessage("");
    const response = await dispatch(
      genetateMobileOtp({
        clinicId,
        mobile: mobileNumber,
        token,
      })
    ).unwrap();
    if (response.success) {
      setShowOtpInput(true);
      startMobileOtpTimer();
      setIsEditable(true);
      setMobileOtpDigits(["", "", "", "", "", ""]);
      setCanSendOtp(false);
    } else {
      setAbhaNumberErrorMessage(
        "something went wrong, Please Provide Valid Mobile Number"
      );
    }
  };

  return (
    <>
      {showAbhaCard ? (
        <>
          <div className={styles.abhaCardContainer}>
            {abhaCard && (
              <img
                src={abhaCard}
                alt="ABHA Card"
                className={styles.abhaCardImage}
              />
            )}
          </div>
          <div className={styles.buttonRow}>
            <button
              className="btn btn-primary me-2"
              onClick={handleDownloadAbhaCard}
            >
              Download
            </button>
            <button
              className="btn btn-primary"
              onClick={handleFinalEndNextClick}
              disabled={loading}
            >
              Next
            </button>
          </div>
        </>
      ) : showAbhaAddressSection ? (
        <div>
          <label className="col-form-label">
            ABHA Address :<span style={{ color: "red" }}>*</span>
          </label>
          <small className="text-muted">
            Please select one or create your own custom ABHA address.{" "}
          </small>
          <select
            className="form-control"
            value={selectedAbhaAddress}
            onChange={handleAbhaAddressChange}
            style={{ marginBottom: "1rem" }}
          >
            <option value="">-- Select ABHA Address --</option>
            {abhaAddressList?.map((abha, index) => (
              <option key={index} value={abha}>
                {abha}
              </option>
            ))}
          </select>

          <div className="text-center mb-3 fw-bold">OR</div>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. john_doe01 or jane.doe12"
            value={manualAbhaAddress}
            onChange={handleManualAbhaChange}
          />

          {abhaAddressErrorMessage && (
            <p className="text-danger">{abhaAddressErrorMessage}</p>
          )}

          <div className="text-end" style={{ marginTop: "1rem" }}>
            <button className="btn btn-primary" onClick={handleEndNextClick}>
              {loading ? "Processing..." : "Next"}
            </button>
          </div>
        </div>
      ) : showAlreadyRegisteredModal ? (
        <div>
          <h2 className="text-xl font-semibold text-center text-red-600 mb-4">
            User already registered with ABHA
          </h2>
          <div className="flex justify-center">
            <button
              onClick={handleGoToPatientRegistration}
              className="btn btn-primary px-4 py-2 mx-auto d-block"
            >
              Go for Patient Registration
            </button>
          </div>
        </div>
      ) : !showOtpVerification &&
        !showMobileEmailVerification &&
        !showFinalStep ? (
        <div>
          <div className={styles.consent}>
            <div className="form-group" style={{ width: "22%" }}>
              <label className="col-form-label">Aadhaar Number :</label>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                name="aadhaarPart1"
                value={aadhaarPart1}
                ref={ref1}
                onChange={(e) =>
                  handleInputChange(e, setAadhaarPart1, 4, ref2, null)
                }
                maxLength={4}
                placeholder="0000"
              />
            </div>
            <div
              className="form-group"
              style={{ width: "25%", marginTop: "2.5rem" }}
            >
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                name="aadhaarPart2"
                value={aadhaarPart2}
                ref={ref2}
                onChange={(e) =>
                  handleInputChange(e, setAadhaarPart2, 4, ref3, ref1)
                }
                maxLength={4}
                placeholder="0000"
              />
            </div>
            <div
              className="form-group"
              style={{ width: "25%", marginTop: "1.3rem" }}
            >
              <label htmlFor=""></label>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                name="aadhaarPart3"
                value={aadhaarPart3}
                ref={ref3}
                onChange={(e) =>
                  handleInputChange(e, setAadhaarPart3, 4, null, ref2)
                }
                maxLength={4}
                placeholder="0000"
              />
            </div>
            <div>
              {showPassword ? (
                <FaEye
                  className="fs-4 mt-3"
                  onClick={togglePasswordVisibility}
                />
              ) : (
                <FaRegEyeSlash
                  className="fs-4 mt-3"
                  onClick={togglePasswordVisibility}
                />
              )}
            </div>
          </div>
          {aadhaarError && (
            <p style={{ color: "red", fontSize: "0.8rem" }}>{aadhaarError}</p>
          )}
          <p className={styles.consentText}>
            <FaExclamationCircle /> Please ensure that the mobile number is
            linked with Aadhaar as it will be required for OTP Authentication.
          </p>

          <div
            className="border p-3 rounded"
            style={{ backgroundColor: "#f8f9fa" }}
          >
            <p className="fw-bold mb-3 small">I hereby declare that:</p>
            {consentTexts?.map((text, index) => {
              const isChildConsent = index >= consentTexts?.length - 2;
              const isLastConsent = index === consentTexts?.length - 1;
              const updatedText = text.replace(
                "(name of healthcare worker)",
                `<strong>${clinicName}</strong>`
              );

              return (
                <div
                  key={index}
                  className={`d-flex align-items-start mb-2 small lh-sm ${
                    isChildConsent ? "ms-4" : ""
                  }`}
                >
                  <input
                    className="form-check-input mt-1 me-2 flex-shrink-0
"
                    type="checkbox"
                    id={`consent-${index}`}
                    checked={checkedState[index]}
                    onChange={() => handleCheckboxChange(index)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`consent-${index}`}
                  >
                    {isLastConsent && text?.includes("(beneficiary name)") ? (
                      (() => {
                        const parts = text?.split("(beneficiary name)");
                        return (
                          <>
                            {parts[0]}
                            <input
                              type="text"
                              placeholder="Enter beneficiary name"
                              value={beneficiaryName}
                              onChange={(e) => {
                                setBeneficiaryName(e.target.value);
                                setBeneficiaryNameError("");
                              }}
                              className="mx-1 px-1 py-0 fs-6"
                              required
                              aria-invalid={!!beneficiaryNameError}
                            />
                            {parts[1]}
                          </>
                        );
                      })()
                    ) : (
                      <span dangerouslySetInnerHTML={{ __html: updatedText }} />
                    )}
                  </label>
                </div>
              );
            })}
            {showConsentError && (
              <div className="text-danger mt-3">
                Please accept all consents to proceed.
              </div>
            )}
            {beneficiaryNameError && (
              <div className="text-danger mt-2">{beneficiaryNameError}</div>
            )}
          </div>
          <div className="text-end">
            <button
              className="btn btn-primary"
              onClick={handleNextClick}
              disabled={loading}
            >
              {loading ? "Processing..." : "Next"}
            </button>
          </div>
        </div>
      ) : !showMobileEmailVerification && !showFinalStep ? (
        <div className={styles.adhaarDiv}>
          <p>Confirm OTP</p>
          <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
            <div
              className="form-group"
              style={{ width: "70%", marginBottom: "0.4rem" }}
            >
              <label className="col-form-label">{adharOtpGenerateMsg}</label>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    className="form-control"
                    value={digit}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    maxLength={1}
                    ref={(el) => (inputRefs.current[index] = el)}
                    style={{ width: "4rem", textAlign: "center" }}
                  />
                ))}
              </div>
              {otpError && (
                <p
                  style={{
                    color: "red",
                    marginTop: "0.5rem",
                    fontSize: "0.75rem",
                  }}
                >
                  {otpError}
                </p>
              )}
              {aadhaarOtpResendCount > 0 && (
                <p
                  className={`small mt-2 mb-0 fw-bold ${
                    aadhaarOtpResendCount >= MAX_OTP_RESEND_ATTEMPTS
                      ? "text-danger"
                      : "text-success"
                  }`}
                >
                  {getOtpResendAttemptMessage(aadhaarOtpResendCount)}
                </p>
              )}
              <small className="fs-13">Didn't receive the OTP?</small>
              {aadhaarOtpResendCount < MAX_OTP_RESEND_ATTEMPTS ? (
                <small
                  onClick={timer === 0 ? handleResendOtp : undefined}
                  style={{
                    cursor: timer === 0 ? "pointer" : "not-allowed",
                    color: timer === 0 ? "#007bff" : "gray",
                    userSelect: "none",
                  }}
                  className="fs-12 fw-bold"
                >
                  Resend OTP
                </small>
              ) : (
                <small className="text-secondary fs-13 fw-bold">
                  Resend OTP limit reached. Please try again later.
                </small>
              )}

              {aadhaarOtpResendCount < MAX_OTP_RESEND_ATTEMPTS && (
                <small className="text-danger fs-13 fw-bold">
                  {timer > 0
                    ? `${String(Math.floor(timer / 60)).padStart(
                        2,
                        "0"
                      )}:${String(timer % 60).padStart(2, "0")} Remaining`
                    : "You can resend OTP now"}
                </small>
              )}
            </div>
          </div>
          <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
            <div className="form-group" style={{ width: "60%" }}>
              <label className="col-form-label">Mobile Number :</label>
              <input
                type="text"
                className="form-control"
                name="mobile"
                value={mobileNumber}
                onChange={(e) => {
                  handleInputChange(e, setMobileNumber, 10);
                  setMobileError("");
                }}
                maxLength={10}
              />
              {mobileError && (
                <span
                  style={{
                    color: "red",
                    marginTop: "0.5rem",
                    fontSize: "0.7rem",
                  }}
                >
                  {mobileError}
                </span>
              )}
              <p className={styles.adharConsentText}>
                <span>
                  <FaExclamationCircle />
                </span>
                It is preferable to use your Aadhaar-linked mobile number
              </p>
            </div>
          </div>
          <div className="text-end">
            <button
              className="btn btn-primary"
              onClick={handleFinalNextClick}
              disabled={loading}
            >
              {loading ? "Processing..." : "Next"}
            </button>
          </div>
        </div>
      ) : !showFinalStep ? (
        <div className={styles.mobEmailDiv}>
          <div style={{ display: "block" }}>
            {showAbhaMob && (
              <div className="form-group">
                <label className="fw-bold">Mobile Number:</label>
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="text"
                    className="form-control w-50"
                    value={mobileNumber}
                    onChange={handleMobileChange}
                    maxLength={10}
                    disabled={isEditable}
                  />
                  {isEditable && (
                    <button
                      type="button"
                      onClick={handleEditClick}
                      className="btn btn-link p-0"
                      style={{ fontSize: "0.9rem" }}
                    >
                      Edit
                    </button>
                  )}
                  {canSendOtp && (
                    <button
                      type="button"
                      onClick={handleSendClick}
                      className="btn btn-link p-0"
                      style={{ fontSize: "0.9rem" }}
                    >
                      Send
                    </button>
                  )}
                </div>
                {abhaNumberErrorMessage && (
                  <p className="text-danger">{abhaNumberErrorMessage}</p>
                )}
              </div>
            )}

            {showOtpInput && (
              <div
                className="form-group"
                style={{ width: "70%", marginBottom: "0.4rem" }}
              >
                <label className="col-form-label">Mobile Number OTP:</label>
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  {mobileOtpDigits.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      className="form-control"
                      value={digit}
                      onChange={(e) => handleMobileOtpChange(e, index)}
                      onKeyDown={(e) => handleMobileOtpKeyDown(e, index)}
                      maxLength={1}
                      ref={(el) => (mobileOtpRefs.current[index] = el)}
                      style={{ width: "3rem", textAlign: "center" }}
                    />
                  ))}
                </div>
                <div
                  style={{
                    marginTop: "0.5rem",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <small className="fs-13">Didn't receive the OTP?</small>

                    {mobileOtpResendCount < MAX_OTP_RESEND_ATTEMPTS ? (
                      <>
                        <small
                          onClick={
                            mobileTimer === 0 ? handleResendMobileOtp : undefined
                          }
                          style={{
                            cursor: mobileTimer > 0 ? "not-allowed" : "pointer",
                            color: mobileTimer > 0 ? "gray" : "#007bff",
                          }}
                          className="fs-12 fw-bold"
                        >
                          Resend OTP
                        </small>
                        <small className="text-secondary fs-13 fw-bold">
                          {mobileTimer > 0
                            ? `${String(Math.floor(mobileTimer / 60)).padStart(
                                2,
                                "0"
                              )}:${String(mobileTimer % 60).padStart(
                                2,
                                "0"
                              )} Remaining`
                            : "You can resend OTP now"}
                        </small>
                      </>
                    ) : (
                      <small className="text-secondary fs-13 fw-bold">
                        Resend OTP limit reached. Please try again later.
                      </small>
                    )}
                  </div>
                </div>
                {mobileOtpResendCount > 0 && (
                  <p
                    className={`small mt-2 mb-0 fw-bold ${
                      mobileOtpResendCount >= MAX_OTP_RESEND_ATTEMPTS
                        ? "text-danger"
                        : "text-success"
                    }`}
                  >
                    {getOtpResendAttemptMessage(mobileOtpResendCount)}
                  </p>
                )}
                {mobileOtpError && (
                  <p style={{ color: "red", marginTop: "0.5rem" }}>
                    {mobileOtpError}
                  </p>
                )}
              </div>
            )}
            <div className="text-end" style={{ marginTop: "1rem" }}>
              <button
                className="btn btn-primary"
                onClick={handleLastNextClick}
                disabled={mobileOtpError || loading}
                title={
                  !selectedAbhaAddress ? "Please select an ABHA Address." : ""
                }
              >
                {loading ? "Processing..." : "Next"}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AdharRegistration;
